export default __webpack_public_path__ + "static/media/2ef09122439b62a2.afc65f299e8f00fe4f67e3d998eacd16.svg";